import { render, staticRenderFns } from "./ProductContentList.vue?vue&type=template&id=6910a15a&scoped=true&"
import script from "./ProductContentList.vue?vue&type=script&lang=js&"
export * from "./ProductContentList.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentList.vue?vue&type=style&index=0&id=6910a15a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6910a15a",
  null
  
)

export default component.exports